export interface LoginType {
  id?: number;
  email?: string;
  password?: string;
  otp?: string;
  is_active?: Boolean;
  first_name?: string;
  last_name?: string;
  username?: string;
  role?: number;
  token?: string;
}

export class Login implements LoginType {
  email: string;
  password: string;
  otp?: string;
  is_active?: Boolean;
  first_name?: string;
  last_name?: string;
  username?: string;
  role?: number;

  constructor(
    email?: string, password?: string, active?: Boolean, first_name?: string,
    last_name?: string, username?: string, role?: number) {
    this.email = email;
    this.password = password || 'abc123456';
    this.is_active = active || false;
    this.first_name = first_name;
    this.username = username;
    this.role = role;
  }
}
